export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/d9f26165e744ef064b81249371ce3c44.svg";